import { types, flow, Instance } from 'mobx-state-tree';
import axios from 'server';
import { SyncZoomUserView, SyncZoomGroupsView } from './types';
import { AxiosResponse } from 'axios';
import {
  syncZoomUserModel,
  IsyncZoomUserModel,
  syncZoomGroupModel,
  IsyncZoomGroupModel,
} from './models/zoomtable.model';

const { model, array, maybeNull, reference } = types;
export const ZoomStore = model('ZoomStore', {
  syncusers: array(syncZoomUserModel),
  syncgroups: array(syncZoomGroupModel),
  clickedUser: maybeNull(reference(syncZoomUserModel)),
  clickedGroup: maybeNull(reference(syncZoomGroupModel)),
})
  .views((self) => ({
    get allsyncUsersView(): SyncZoomUserView[] {
      const allsyncUsersView: SyncZoomUserView[] = [];
      for (let i = 0; i < self.syncusers.length; i++) {
        allsyncUsersView.push({ ...self.syncusers[i], id: i });
      }
      return allsyncUsersView;
    },
    get allsyncGroupsView(): SyncZoomGroupsView[] {
      const allsyncGroupsView: SyncZoomGroupsView[] = [];
      for (let i = 0; i < self.syncgroups.length; i++) {
        allsyncGroupsView.push({ ...self.syncgroups[i], id: i });
      }
      return allsyncGroupsView;
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeUsers({ data }: AxiosResponse): IsyncZoomUserModel[] {
      self.syncusers.replace(data?.users);
      return self.syncusers;
    },
    normalizeGroups({ data }: AxiosResponse): IsyncZoomGroupModel[] {
      self.syncgroups.replace(data?.groups);
      return self.syncgroups;
    },
    clearSelected(): void {
      self.clickedUser = null;
      self.clickedGroup = null;
    },
  }))

  .actions((self) => ({
    syncUser: flow(function* () {
      const result = yield axios
        .get<IsyncZoomUserModel[]>(`apps/zoom/users`)
        .then(self.normalizeUsers)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    reSyncUser: flow(function* () {
      const result = yield axios
        .get<IsyncZoomUserModel[]>(`admin/app/zoom/master-sync/user`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    reSyncSingleUser: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncZoomUserModel[]>(`apps/zoom/sync/user`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    syncGroup: flow(function* () {
      const result = yield axios
        .get<IsyncZoomGroupModel[]>(`apps/zoom/groups`)
        .then(self.normalizeGroups)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    reSyncGroup: flow(function* () {
      const result = yield axios
        .get<IsyncZoomGroupModel[]>(`admin/app/zoom/master-sync/group`)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    reSyncSingleGroup: flow(function* (data: any) {
      const result = yield axios
        .post<IsyncZoomGroupModel[]>(`apps/zoom/sync/group`, data)
        .then(self.clearSelected)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type IZoomStore = Instance<typeof ZoomStore>;
